/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import Typography from "@mui/material/Typography";
import { Stack, StackProps, SxProps, Theme } from "@mui/material";
import React from "react";
import FooterLink, { FooterLinkProps } from "@/src/components/Footer/FooterLink.tsx";

export type FooterLinkListProps = {
  title?: string | null;
  links: FooterLinkProps[];
  sx?: SxProps<Theme>;
  spacing?: Extract<StackProps["spacing"], object>
} & Omit<StackProps, "spacing">;

export default function FooterLinkList({ title, links, spacing, ...stackProps }: FooterLinkListProps) {

  return (
    <Stack {...stackProps} spacing={{ xs: "1.5rem", ...spacing }}>
      {!!title && <Typography variant={"h6"} component="p">{title}</Typography>}
      {links.map((linkProps, idx) => {
        return <FooterLink key={idx} {...linkProps} />;
      })}
    </Stack>
  );
}
